
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qr/wifi",
      function () {
        return require("private-next-pages/qr/wifi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qr/wifi"])
      });
    }
  